import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-permit-to-work-template',
  templateUrl: './permit-to-work-template.component.html',
  styleUrls: ['./permit-to-work-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PermitToWorkTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;
}
